import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Features } from "@/components/Features";
import { HowItWorks } from "@/components/HowItWorks";
import { AskingVsRealized } from "@/components/AskingVsRealized";
import { ReportShowcase } from "@/components/ReportShowcase";
import { Pricing } from "@/components/Pricing";
import { FAQ } from "@/components/FAQ";
import { Footer } from "@/components/Footer";
import { SkipToContent } from "@/components/SkipToContent";
import { StickyMobileCta } from "@/components/StickyMobileCta";
import { AnnouncementBar } from "@/components/AnnouncementBar";

const Index = () => {
  return (
    <div className="min-h-screen">
        <SkipToContent />
        <Header />
        <main id="main-content" tabIndex={-1} className="pt-16 outline-none">
          <AnnouncementBar />
          <Hero />
          <Features />
          {/* Placed before HowItWorks: the review treats this gap as both the
              demonstration of the product and the reason to buy, so it belongs
              ahead of the mechanics. */}
          <AskingVsRealized />
          <HowItWorks />
          <ReportShowcase />
          <Pricing />
          <FAQ />
        </main>
        <Footer />
        <StickyMobileCta />
      </div>
  );
};

export default Index;
